import React, { useEffect, useState } from "react";
import Autocomplete from "@material-ui/lab/Autocomplete";
import Grid from "@material-ui/core/Grid";
import TextField from "@material-ui/core/TextField";
import { Button, colors, Divider, Hidden } from "@material-ui/core";
import { useStylesTF, useStylesLbl } from "../../../../../St/comps/UseStyle";
import ReceiptVoucherType from "../components/ReceiptVoucher-typeFilter";
import { personTypes } from "../../../../../services/InernalVoucher-service";
import { useTranslation } from "react-i18next";
import { GetItemFromOptions } from "../../../../../services/global-services";
import { sto } from "../../../../../Context/InshData";
import RestInfoDialog from "../../../../Invs/BackEnd/models/RestInfo/RestInfoDialog";

export default function IReceiptoucherForm(props) {
  const { changAutoCustomers, onChange, AutoOptions, object, formType,
    AutoOptionsB,
    branch,
    setBranch,
    branchT,
    optionsStocks,
    isMobileDevice,
    prmis
  } = props;
  const clasTF = useStylesTF();
  const claslbl = useStylesLbl();
  const valuebranch = GetItemFromOptions(formType === "edit" && !props.isDialogData ? branchT : props.isDialogData ? props.invData.branch : branch.id === -1 ?? sto.branchi, AutoOptionsB.Branches ?? []);
  const onChangeAutoData = (propName, newValue) => {
    onChange(null, { name: "branch", value: newValue.id });
    setBranch(newValue);
  };
  const { t } = useTranslation(["forms"]);
  const [infoData, setInfoData] = useState({ open: false });

  return (
    <React.Fragment>
      <Grid container style={{ padding: isMobileDevice ? 5 : 10 }} spacing={2}>
        <Grid item lg={3} md={4} sm={4} xs={12}>
          <Autocomplete
            value={branch.id == -1 ? valuebranch : branch}
            onChange={(event, newValue) => {
              onChangeAutoData("branch", newValue);
            }}
            id="controllable-states-demo"
            size="small"
            options={AutoOptionsB.Branches}
            getOptionLabel={(option) =>
              typeof option === "string" ? option : option.name
            }
            disableClearable
            disabled={formType == "edit" ? true : props.isDialogData == true ? true : sto.User_typei == 1 ? false : true}
            renderInput={(params) => (
              <TextField
                id="valueCostcenter"
                {...params}
                label={"الفرع"}
                variant="outlined"
                size="small"
                InputLabelProps={{ className: claslbl.clor }}
              />
            )}
          />
        </Grid>
        <Grid item lg={3} md={4} sm={4} xs={6}>
          <TextField
            type="text"
            fullWidth
            variant="outlined"
            size="small"
            id="id"
            label={t("voucher-id")}
            className={clasTF.rootEDS}
            InputProps={{ className: clasTF.input, readOnly: true }}
            name="id"
            value={object.id}
          />
        </Grid>
        <Grid item lg={3} md={4} sm={4} xs={6}>
          <TextField
            fullWidth
            variant="outlined"
            size="small"
            id="date"
            label={t("date")}
            className={clasTF.rootEDS}
            type="date"
            format="YYYY-MM-DD"
            InputLabelProps={{ shrink: true }}
            name="date"
            value={object.date}
            disabled={!prmis?.USD }
            onChange={(e) =>
              onChange(null, { name: "date", value: e.target.value })
            }
          />
        </Grid>
        <Grid item lg={3} md={4} sm={4} xs={6}>
          <Autocomplete
            value={object.emp_person}
            onChange={(event, newValue) => {
              onChange(null, { name: "emp_person", value: newValue });
            }}
            id="controllable-states-demo"
            size="small"
            options={personTypes}
            getOptionLabel={(option) =>
              typeof option === "string" ? option : option.name
            }
            disableClearable
            renderInput={(params) => (
              <TextField
                id="valueCustomers"
                {...params}
                label={t("type")}
                variant="outlined"
                size="small"
                InputLabelProps={{ className: claslbl.clor }}
              />
            )}
          />
        </Grid>

        <Grid item lg={12} md={12} sm={12} xs={12}>
          <Divider />
        </Grid>
        <Grid item lg={6} md={6} sm={6} xs={12}>
          <Autocomplete
            value={object.acc_code}
            onChange={(event, newValue) => {
              changAutoCustomers(newValue);
            }}
            id="controllable-states-demo"
            size="small"
            options={AutoOptions.Customers}
            getOptionLabel={(option) =>
              typeof option === "string" ? option : option.name
            }
            style={{ backgroundColor: colors.orange[50] }}
            disableClearable
            renderInput={(params) => (
              <TextField
                id="valueCustomers"
                {...params}
                label={t("payment-from-account")}
                variant="outlined"
                size="small"
                InputLabelProps={{ className: claslbl.clor }}
              />
            )}
          />
        </Grid>
        <Grid item lg={6} md={6} sm={6} xs={12}>
          <TextField
            type="number"
            fullWidth
            variant="outlined"
            size="small"
            id="val"
            label={t("amount")}
            className={clasTF.rootEDS}
            style={{ backgroundColor: colors.grey[50] }}
            InputProps={{ className: clasTF.input }}
            name="val"
            value={object.val}
            onChange={(e) =>
              onChange(null, { name: "val", value: e.target.value })
            }
          />
        </Grid>
        <Grid item lg={12} md={12} sm={12} xs={12}>
          <Divider />
        </Grid>
        <Grid item lg={6} md={6} sm={6} xs={12}>
          <Autocomplete
            value={object.user}
            onChange={(event, newValue) => {
              onChange(null, { name: "user", value: newValue });
            }}
            id="controllable-states-demo"
            size="small"
            options={AutoOptions.Users}
            getOptionLabel={(option) =>
              typeof option === "string" ? option : option.name
            }
            disabled={sto.User_typei == 1 ? false : true}
            disableClearable
            renderInput={(params) => (
              <TextField
                id="valueUsers"
                {...params}
                label={t("received-mr")}
                variant="outlined"
                size="small"
                InputLabelProps={{ className: claslbl.clor }}
              />
            )}
          />
        </Grid>

        <Grid item lg={6} md={6} sm={6} xs={12}>
          <Autocomplete
            value={object.center}
            onChange={(event, newValue) => {
              onChange(null, { name: "center", value: newValue });
            }}
            id="controllable-states-demo"
            size="small"
            options={AutoOptions.costcenters}
            getOptionLabel={(option) =>
              typeof option === "string" ? option : option.name
            }
            disableClearable
            renderInput={(params) => (
              <TextField
                id="valueCostcenter"
                {...params}
                label={t("center")}
                variant="outlined"
                size="small"
                InputLabelProps={{ className: claslbl.clor }}
              />
            )}
          />
        </Grid>
        <Grid item lg={12} md={12} sm={12}>
          <ReceiptVoucherType
            {...{
              type: object.type,
              onChange,
              prmis,
            }}
          />
        </Grid>
        <Grid item lg={6} md={6} sm={6} xs={12}>
          {object.type == "1" ? (
            <Autocomplete
              value={object.stock}
              onChange={(event, newValue) => {
                onChange(null, { name: "stock", value: newValue });
              }}
              id="controllable-states-demoew"
              size="small"
              options={optionsStocks}
              style={{ backgroundColor: colors.grey[50] }}
              getOptionLabel={(option) =>
                typeof option === "string" ? option : option.name
              }
              disableClearable
              renderInput={(params) => (
                <TextField
                  id="valueCostcenter"
                  {...params}
                  label={t("deposited-in-account")}
                  variant="outlined"
                  size="small"
                  InputLabelProps={{ className: claslbl.clor }}
                />
              )}
            />
          ) : (
            <Autocomplete
              value={object.bank}
              onChange={(event, newValue) => {
                onChange(null, { name: "bank", value: newValue });
              }}
              id="controllable-states-demo67"
              size="small"
              options={AutoOptions.Banks}
              style={{ backgroundColor: colors.grey[50] }}
              getOptionLabel={(option) =>
                typeof option === "string" ? option : option.name
              }
              disableClearable
              renderInput={(params) => (
                <TextField
                  id="valueCostcenter"
                  {...params}
                  label={t("deposited-in-account")}
                  variant="outlined"
                  size="small"
                  InputLabelProps={{ className: claslbl.clor }}
                />
              )}
            />
          )}
        </Grid>
        <Grid item lg={6} md={6} sm={12}></Grid>
        <Grid item lg={6} md={6} sm={6} xs={12}>
          <Autocomplete
            value={object.emp}
            onChange={(event, newValue) => {
              onChange(null, { name: "emp", value: newValue });
            }}
            id="controllable-states-demo4"
            size="small"
            options={AutoOptions.Users}
            disabled={sto.User_typei == 1 ? false : true}
            getOptionLabel={(option) =>
              typeof option === "string" ? option : option.name
            }
            disableClearable
            renderInput={(params) => (
              <TextField
                id="valueSalesmen"
                {...params}
                label={t("delegate")}
                variant="outlined"
                size="small"
                InputLabelProps={{ className: claslbl.clor }}
              />
            )}
          />
        </Grid>

        <Grid item lg={formType == "edit" ? 11 : 12} md={formType == "edit" ? 11 : 12} sm={formType == "edit" ? 11 : 12} xs={12}>
          <TextField
            fullWidth
            variant="outlined"
            size="small"
            id="notes"
            label={t("note")}
            className={clasTF.rootEDS}
            InputProps={{ className: clasTF.input }}
            name="notes"
            value={object.notes}
            onChange={(e) =>
              onChange(null, { name: "notes", value: e.target.value })
            }
          />
        </Grid>
        {formType == "edit" && (
          <Grid item lg={1} md={1} sm={4} xs={12} >
            <Hidden only={["xs"]}>
              <Button
                fullWidth
                autoFocus
                variant="contained"
                color="#000"
                onClick={(e) => {
                  setInfoData({ open: true, })
                }}
                style={{
                  background: colors.grey[300],
                  ...{
                    paddingLeft: 0,
                    paddingRight: 0,
                  },
                }}
              >
                {"القيد" + "  "}
              </Button>
            </Hidden>
          </Grid>
        )}

        {formType == "edit" && (
          <RestInfoDialog
            infoData={infoData}
            setInfoData={setInfoData}
            res_id={object.rest_id}
            branch={object.branch}
            fromInv={0}
            proc_id={0}
          />
        )}
      </Grid>
    </React.Fragment>
  );
}
